import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { SITE_CONFIG, WHATSAPP_MESSAGES } from '../config/siteConfig';
import { createWhatsAppUrl, trackEvent } from '../utils/analytics';
export function FinalCTASection() {
  return <section className="bg-[#050511] py-24" data-id="element-905">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8" data-id="element-906">
        <div className="rounded-2xl border border-[#a738f4]/30 bg-[#101022] px-6 py-14 text-center md:px-12" data-id="element-907">
          <h2 className="mx-auto max-w-3xl text-3xl font-bold text-white md:text-5xl" data-id="element-908">
            Tu próximo cliente puede estar buscando tu negocio hoy.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-[#a9a9ba]" data-id="element-909">
            Dale un lugar profesional donde pueda conocer lo que ofrecés y
            escribirte directamente por WhatsApp.
          </p>

          <div className="mx-auto mt-8 flex max-w-lg flex-col gap-3 sm:flex-row sm:justify-center" data-id="element-910">
            <a href={createWhatsAppUrl(WHATSAPP_MESSAGES.final)} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('whatsapp_final_click', {
            cta_location: 'final',
            selected_product: SITE_CONFIG.product.name
          })} className="inline-flex min-h-12 flex-1 items-center justify-center gap-2 rounded-xl bg-[#25d366] px-5 py-3 font-semibold text-[#06170c] transition-colors hover:bg-[#3ee47a] focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-911">
              <MessageCircleIcon className="h-5 w-5" data-id="element-912" />
              Quiero comenzar mi página
            </a>
            <a href={createWhatsAppUrl(WHATSAPP_MESSAGES.diagnostic)} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('diagnostic_click', {
            cta_location: 'final'
          })} className="inline-flex min-h-12 flex-1 items-center justify-center rounded-xl border border-white/15 px-5 py-3 font-semibold text-white transition-colors hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#20d6e8]" data-id="element-913">
              Solicitar diagnóstico gratuito
            </a>
          </div>

          <p className="mt-6 text-sm text-[#9292a3]" data-id="element-914">
            {SITE_CONFIG.product.price} · Lista en siete días hábiles · Dominio
            y hosting por un año
          </p>
        </div>
      </div>
    </section>;
}